import { asyncToGenerator as _asyncToGenerator, objectSpread2 as _objectSpread2, regeneratorRuntime as _regeneratorRuntime } from '../_virtual/_rollupPluginBabelHelpers.js';
import axios from 'axios';

var instance = axios.create({
  baseURL: '/',
  timeout: 50 * 1000
});
axios.defaults.timeout = 20000;
axios.defaults.withCredentials = true;
var TOKEN_EXPIRED = 60 * 15 * 1000;
var configCN = {
  token: "",
  lastUpdateTokenTime: 0,
  defaultStoreId: 20,
  languageId: "1",
  languageCode: "zh-CN"
};
var isRefreshing = false;
instance.interceptors.request.use(function (config) {
  if (config.url !== '/token' && configCN.token) {
    config.headers && (config.headers.Authorization = "Bearer ".concat(configCN.token));
  }
  return config;
});
instance.interceptors.response.use(function (response) {
  return response;
}, /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(err) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(err && err.response)) {
              _context.next = 7;
              break;
            }
            if (!(err.response.status === 401)) {
              _context.next = 7;
              break;
            }
            if (isRefreshing) {
              _context.next = 7;
              break;
            }
            isRefreshing = true;
            _context.next = 6;
            return getToken()["finally"](function () {
              return isRefreshing = false;
            });
          case 6:
            return _context.abrupt("return", new Promise(function (resolve) {
              instance.request(err.config).then(function (res) {
                return resolve(res);
              });
            }));
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
var get = function get(url, config) {
  return new Promise(function (resolve, reject) {
    instance.get(url, config).then(function (res) {
      resolve(res.data);
    }, function (err) {
      reject(err);
    });
  });
};
var post = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(url, data, config) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              instance.post(url, data, config).then(function (res) {
                resolve(res.data);
              }, function (err) {
                reject(err);
              });
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function post(_x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
var getToken = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var force,
      currentTimestamp,
      res,
      _args3 = arguments;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            force = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : false;
            currentTimestamp = new Date().getTime();
            if (!(!force && currentTimestamp - configCN.lastUpdateTokenTime < TOKEN_EXPIRED)) {
              _context3.next = 4;
              break;
            }
            return _context3.abrupt("return", configCN.token || "");
          case 4:
            _context3.next = 6;
            return instance.post('/api/token', {
              key: 'PAX@ikea.com'
            });
          case 6:
            res = _context3.sent;
            configCN.token = res.data.token || configCN.token;
            configCN.defaultStoreId = res.data.storeId || configCN.defaultStoreId;
            configCN.lastUpdateTokenTime = new Date().getTime();
            return _context3.abrupt("return", configCN.token);
          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function getToken() {
    return _ref3.apply(this, arguments);
  };
}();
var syncRequestConfig = function syncRequestConfig(config) {
  configCN = _objectSpread2(_objectSpread2({}, configCN), config);
};

export { instance as default, get, getToken, post, syncRequestConfig };
